import { useParams } from 'react-router-dom';
import TaskListContainer from './components/TaskListContainer';

export default function TaskPage() {
    const { projectId } = useParams();

    if (!projectId) {
        return <div className="p-6 text-sm text-rose-700">잘못된 프로젝트 ID입니다.</div>;
    }

    return (
        <div className="w-full //p-6 space-y-4">
            <div className="flex items-end justify-between mb-2">
                <h1 className="text-lg font-semibold">Project Task Management</h1>
            </div>
            <TaskListContainer projectId={projectId} />
        </div>
    );
}
